var map = {
	"./007-microphone-1.png": 303,
	"./010-home.png": 305,
	"./013-document-1.png": 307,
	"./014-document.png": 306,
	"./015-color-palette.png": 308,
	"./017-video-camera.png": 304,
	"./arrow-left.svg": 354,
	"./arrow-right.svg": 355,
	"./image.png": 366,
	"./label.png": 381,
	"./left.svg": 382,
	"./quote.png": 383,
	"./right.svg": 367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 511;